var map = {
	"./faq-1.svg": 3289,
	"./faq-2.svg": 1381,
	"./faq-4.svg": 4728,
	"./faq-5.svg": 1686,
	"./faq-6.svg": 3975,
	"./faq-7.svg": 6098,
	"./fullscreen.svg": 9672,
	"./ic_crown.svg": 8209,
	"./ic_full.svg": 1756,
	"./ic_lang.svg": 1098,
	"./ic_radio.svg": 4654,
	"./ic_sort.svg": 3851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;